import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import React, { createContext, useContext } from 'react';
const defaultContext = {
    openAsset: () => { },
    closeAsset: () => { },
    isOpen: false,
    openAssetInfo: null,
    setAllSharedAssets: () => { },
    registerPageViewer: () => () => { },
};
export const ComputerAssetViewerContext = createContext(null);
export const ComputerAssetViewerHost = Dynamic(async () => {
    const { ComputerAssetViewerHost } = await import('#pplx/frontend/apps/ask/computer/asset-viewer/ComputerAssetViewerHost.js');
    return { default: ComputerAssetViewerHost };
});
export function getAssetDisplayName(asset) {
    return (asset.app?.name ??
        asset.chart?.name ??
        asset.code_file?.filename ??
        asset.pdf_file?.name ??
        asset.docx_file?.name ??
        asset.doc_file?.name ??
        asset.xlsx_file?.name ??
        asset.slide_file?.name ??
        asset.audio_file?.name ??
        asset.audio_file?.filename ??
        asset.model_3d?.name ??
        asset.model_3d?.filename ??
        asset.research_report?.name ??
        asset.quiz?.title ??
        asset.flashcards?.title ??
        asset.download_info?.[0]?.filename ??
        asset.asset_type ??
        'Unknown');
}
export function useComputerAssetViewer() {
    return useContext(ComputerAssetViewerContext) ?? defaultContext;
}
//# sourceMappingURL=ComputerAssetViewerContextShared.js.map